import { render, staticRenderFns } from "./NotificationListComponent.vue?vue&type=template&id=8f55f024&"
import script from "./NotificationListComponent.vue?vue&type=script&lang=js&"
export * from "./NotificationListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports